<template>
  <v-select
    v-if="!isLoading"
    :items="items"
    v-model="model"
    label="List of discounts"
    item-text="resume"
    item-value="resume"
    return-object
    :disabled="disabled"
    :rules="rules"
  ></v-select>
</template>

<script>
export default {
  data() {
    return {
      model: this.value,
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      items: []
    };
  },
  props: {
    endpoint: {
      type: String,
      default: "orderDiscounts/list"
    },
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    model() {
      this.$emit("input", this.model);
    }
  },
  mounted: function() {
    this.getDiscounts();
  },
  methods: {
    getDiscounts() {
      this.$store
        .dispatch(this.endpoint, {})
        .then(({discounts}) => {
          this.items = discounts;
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>
